<form [formGroup]="createForm" (submit)="submitForm()" [class]="templ()">
    <div class="bg-white mx-auto tmpl-forms">
      <div class="d-flex flex-column align-items-start">
        <div class="block-field-name">
          {{ 'newGame.txtFieldName' | translate }}
        </div>
        <div class="block-field w-100">
          <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
              <input matInput placeholder="{{ 'newGame.txtNameGame' | translate }}" required formControlName="gameTitle" (blur)="blurInput()"/>
              @if(createForm.get('gameTitle')?.hasError('invalid')){
                <mat-error>errorMessage</mat-error>
              }
              @if(createForm.get('gameTitle')?.hasError('required')){
                <mat-error>{{ 'error.txtGameTitle' | translate }}</mat-error>
              }
          </mat-form-field>
        </div>
        <div class="block-field-name d-flex align-items-center justify-content-between w-100">
          <span>{{ 'newGame.txtCode' | translate }}</span>
          <span class="dop-text-info">{{ 'newGame.txtNoRequired' | translate }}</span>
        </div>
        <div class="block-field w-100">
          <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
              <input matInput placeholder="{{ 'newGame.txtCodePlaceholder' | translate }}" formControlName="code" maxlength="4"/>
                @if(createForm.get('code')?.hasError('maxlength') && createForm.get('code')?.touched){
                  <mat-error>{{ 'error.txtCodeMaxLength' | translate }}</mat-error>
                }
          </mat-form-field>
        </div>
        <div class="block-field-name">
          {{ 'newGame.txtCountPlayer' | translate }}
        </div>
        <div class="block-field w-100 count-select d-flex align-items-center justify-content-between">
          @for (count of countArraySelect; track count) {
              @if(count === createForm.get('countPlayer')?.value){
                  <div class="item-count selected d-flex align-items-center justify-content-center w-100">
                      <span>{{ count }}</span>
                  </div>
              }@else {
                  <div class="item-count d-flex align-items-center justify-content-center w-100" (click)="changeCount(count)">
                      <span>{{ count }}</span>
                  </div>
              }
          }
        </div>
        <div class="line" style="margin: 0;"></div>
        <div class="d-flex flex-column align-items-center justify-content-center mode-info">
          <div class="desctop">
            <img src="./assets/group_small.png" alt="" srcset="">
            <div class="d-flex flex-column align-items-center mode-info-text">
              <span class="mode-text">{{ 'create.txtGMode' | translate }}</span> 
              <span class="info-text">{{ 'create.txtQuest' | translate }}</span>
            </div>
          </div>
          <div class="mobile d-flex flex-column align-items-center">
            <div class="svg">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 33L29 29L33 15L19 19L15 33ZM24 27C23.1667 27 22.4583 26.7083 21.875 26.125C21.2917 25.5417 21 24.8333 21 24C21 23.1667 21.2917 22.4583 21.875 21.875C22.4583 21.2917 23.1667 21 24 21C24.8333 21 25.5417 21.2917 26.125 21.875C26.7083 22.4583 27 23.1667 27 24C27 24.8333 26.7083 25.5417 26.125 26.125C25.5417 26.7083 24.8333 27 24 27ZM24 44C21.2333 44 18.6333 43.475 16.2 42.425C13.7667 41.375 11.65 39.95 9.85 38.15C8.05 36.35 6.625 34.2333 5.575 31.8C4.525 29.3667 4 26.7667 4 24C4 21.2333 4.525 18.6333 5.575 16.2C6.625 13.7667 8.05 11.65 9.85 9.85C11.65 8.05 13.7667 6.625 16.2 5.575C18.6333 4.525 21.2333 4 24 4C26.7667 4 29.3667 4.525 31.8 5.575C34.2333 6.625 36.35 8.05 38.15 9.85C39.95 11.65 41.375 13.7667 42.425 16.2C43.475 18.6333 44 21.2333 44 24C44 26.7667 43.475 29.3667 42.425 31.8C41.375 34.2333 39.95 36.35 38.15 38.15C36.35 39.95 34.2333 41.375 31.8 42.425C29.3667 43.475 26.7667 44 24 44ZM24 40C28.4333 40 32.2083 38.4417 35.325 35.325C38.4417 32.2083 40 28.4333 40 24C40 19.5667 38.4417 15.7917 35.325 12.675C32.2083 9.55833 28.4333 8 24 8C19.5667 8 15.7917 9.55833 12.675 12.675C9.55833 15.7917 8 19.5667 8 24C8 28.4333 9.55833 32.2083 12.675 35.325C15.7917 38.4417 19.5667 40 24 40Z" fill="black" fill-opacity="0.2"/>
              </svg>
            </div>
            <span class="info-text">{{ 'newGame.txtQuest' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
        <div class="d-flex justify-content-between align-items-center my-23125">
            <div class="d-flex justify-content-start align-items-center w-100 mobile-step-1">
              <div class="d-flex justify-content-start align-items-center left-complex-button" (click)="ExitCreateRoom()">
                <button type="button" class="example-icon d-flex justify-content-center align-items-center">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.33341 15.8332L4.16675 14.6665L8.83342 9.99984L4.16675 5.33317L5.33341 4.1665L10.0001 8.83317L14.6667 4.1665L15.8334 5.33317L11.1667 9.99984L15.8334 14.6665L14.6667 15.8332L10.0001 11.1665L5.33341 15.8332Z" fill="#262626"/>
                    </svg>
                </button>
                <span class="sub-button-title">{{ 'buttons.txtCancel' | translate }}</span>
              </div>  
            </div>
            <div class="d-flex justify-content-center align-items-center w-100">
              @if(!isCreateClick){
                <button type="submit" class="d-flex justify-content-center align-items-center gap-2 btn-next" [disabled]="!createForm.valid">
                    <span>{{ 'buttons.txtCreate' | translate }}</span>
                </button>
              }@else{
                <button type="submit" class="d-flex justify-content-center align-items-center gap-2 btn-next" [disabled]="!createForm.valid">
                    <span>{{ 'buttons.txtCreating' | translate }}</span> 
                    <span class="material-symbols-outlined">progress_activity</span>
                </button>
              }
                
            </div>
            <div class="d-flex justify-content-end align-items-center w-100 mobile-step-3"></div>
        </div>
      </form>
